import { HttpService } from "data/http-service";
import { Snackbar } from "ui/pages/snackbar";
import { translate } from "ui/i18n";
import { AxiosError } from "axios";
import {
  Consigne,
  CreateConsigne,
  UpdateConsigne,
} from "domain/entities/consignes.entities";
import { ConsignesGateway } from "domain/consignes/consignes.gateway";
import { consignesDtoSchema } from "./consignes.dto.schemas";

export class ConsignesHttpGateway implements ConsignesGateway {
  async createConsigne(consigne: CreateConsigne): Promise<{
    success: boolean;
    consigne: Consigne | null;
  }> {
    return HttpService.post(
      `consignes`,
      {
        title: consigne.title,
        content: consigne.content,
        duration: consigne.duration,
        icon: "equipe",
        userId: consigne.userId,
      },
      { params: { techniqueId: consigne.techniqueId, order: consigne.order } }
    )
      .then((response) => {
        if (response.status === 201 && response.data.id) {
          return {
            consigne: response.data as Consigne,
            success: true,
          };
        } else {
          Snackbar.showError({
            title: translate("ns1:TechniqueConsignes.CreationError"),
          });
          return {
            consigne: null,
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        Snackbar.showError({
          title: translate("ns1:TechniqueConsignes.CreationError"),
        });
        return { consigne: null as Consigne, success: false };
      });
  }

  async getConsignesByTechniqueId(id: number): Promise<{
    consignes: Consigne[] | [];
    success: boolean;
  }> {
    return HttpService.get(`consignes`, {
      params: { techniqueId: id },
    })
      .then((response) => {
        if (response.status === 200) {
          const parsedConsignes = consignesDtoSchema.safeParse(
            response.data.data
          );
          if (parsedConsignes.success) {
            return {
              consignes: parsedConsignes.data,
              success: true,
            };
          } else return { consignes: [], success: false };
        } else {
          return {
            consignes: [] as Consigne[],
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        return { consignes: [] as Consigne[], success: false };
      });
  }

  async deleteConsigne(consigneId: number): Promise<{
    success: boolean;
  }> {
    return HttpService.delete(`consignes/${consigneId}`)
      .then((response) => {
        if (response.status === 200) {
          return { success: true };
        } else {
          Snackbar.showError({
            title: translate("ns1:TechniqueConsignes.DeleteError"),
          });
          return {
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        Snackbar.showError({
          title: translate("ns1:TechniqueConsignes.DeleteError"),
        });
        return { success: false };
      });
  }

  async updateConsigne(consigne: UpdateConsigne): Promise<{
    success: boolean;
  }> {
    return HttpService.patch(
      `consignes/${consigne.id}`,
      {
        title: consigne.title,
        content: consigne.content,
        duration: consigne.duration,
      },
      { params: { order: consigne.order } }
    )
      .then((response) => {
        if (response.status === 200) {
          return { success: true };
        } else {
          Snackbar.showError({
            title: translate("ns1:TechniqueConsignes.UpdateError"),
          });
          return {
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        Snackbar.showError({
          title: translate("ns1:TechniqueConsignes.UpdateError"),
        });
        return { success: false };
      });
  }
}
